import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SmartLink from '../common/SmartLink';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import logoImg from '../assets/logo.jpeg';
import { defaultContent } from '../lib/defaultContent';

const { FiMenu, FiX } = FiIcons;

export default function Navbar({ content }) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const logo = content?.logo || defaultContent.global.logo;
  const currentNavLinks = content?.navLinks || defaultContent.global.navLinks;
  const headerButtonText = content?.headerButtonText || defaultContent.global.headerButtonText;
  const headerButtonLink = content?.headerButtonLink || defaultContent.global.headerButtonLink;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 print:hidden ${scrolled ? 'bg-white dark:bg-brand-slate/95 dark:bg-brand-slate/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <SmartLink to="/" className="flex items-center space-x-3  ">
            <img 
              src={logo.image}
              alt="Logo"
              className="w-10 h-10 rounded-full object-cover border-2 border-brand-rose shadow-sm"
            />
            <span className="font-bold text-xl tracking-tight" style={{ fontFamily: "'Comic Sans MS', 'Chalkboard SE', 'Comic Neue', sans-serif" }}>{logo.text}</span>
          </SmartLink>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-8">
            {currentNavLinks.map((link) => (
              <SmartLink
                key={link.name}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-brand-rose ${
                  location.pathname === link.path ? 'text-brand-rose' : ' '
                }`}
              >
                {link.name}
              </SmartLink>
            ))}
            <SmartLink to={headerButtonLink} className="px-10 py-4 bg-brand-rose text-white dark:text-white rounded-full font-medium text-center hover:brightness-110 transition-all shadow-[2px_2px_0px_0px_rgba(45,55,72,1)] border-2 border-brand-darkGray hover:translate-y-1 hover:shadow-none flex items-center justify-center gap-2">
              {headerButtonText}
            </SmartLink>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center">
            <button onClick={() => setIsOpen(!isOpen)} className="  focus:outline-none">
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="lg:hidden bg-white dark:bg-brand-slate dark:bg-brand-slate shadow-xl absolute w-full left-0 top-full">
          <div className="px-4 pt-2 pb-6 space-y-1">
            {currentNavLinks.map((link) => (
              <SmartLink
                key={link.name}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-4 border-b border-sand-100 text-base font-medium hover:text-brand-rose ${
                  location.pathname === link.path ? 'text-brand-rose' : ' '
                }`}
              >
                {link.name}
              </SmartLink>
            ))}
            <div className="pt-4">
              <SmartLink to={headerButtonLink} className="block w-full text-center px-10 py-4 bg-brand-rose text-white dark:text-white rounded-full font-medium hover:brightness-110 transition-all shadow-[2px_2px_0px_0px_rgba(45,55,72,1)] border-2 border-brand-darkGray hover:translate-y-1 hover:shadow-none flex items-center justify-center gap-2">
                {headerButtonText}
              </SmartLink>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
